export default __webpack_public_path__ + "static/media/project2.78bfbc57.jpg";